// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ContainerControl } from '../../ContainerControl';
import VideoWidgetItemSideBarTemplate from '@front/templates/VideoWidgetItemSideBarTemplate.html';
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { Resources } from '@shared/localizations/Resources';
import { externalScreenHandler } from '@shared/utils/AppHandlers';
import { ExtLinkUtils } from '@shared/commons/UtilsClasses/ExtLinkUtils';
import { YoutubeExtLink } from '@shared/commons/cache/ExternalLink/YoutubeExtLink';
import { ExternalLinksObserver } from '@shared/commons/UtilsClasses/Observers/ExternalLinksObserver';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
export class VideoWidgetItemSideBar extends ContainerControl {
    get Link() {
        return this.get('externalLink');
    }
    set Link(value) {
        void this.set('externalLink', value);
    }
    get VideoPreviewURL() {
        return this.get('videoPreviewURL');
    }
    set VideoPreviewURL(value) {
        void this.set('videoPreviewURL', value);
    }
    get ChannelName() {
        return this.get('channelName');
    }
    set ChannelName(value) {
        void this.set('channelName', value);
    }
    get ChannelPic() {
        return this.get('channelPic');
    }
    set ChannelPic(value) {
        void this.set('channelPic', value);
    }
    get Title() {
        return this.get('title');
    }
    set Title(value) {
        void this.set('title', value);
    }
    get StreamHasBeenAlreadyEnded() {
        return this.get('streamHasBeenAlreadyEnded');
    }
    set StreamHasBeenAlreadyEnded(value) {
        void this.set('streamHasBeenAlreadyEnded', value);
    }
    get IsLIVE() {
        return this.get('isLive');
    }
    set IsLIVE(value) {
        void this.set('isLive', value);
    }
    get isShowData() {
        return this.get('isShowData');
    }
    set isShowData(value) {
        void this.set('isShowData', value);
    }
    get StreamStartDate() {
        return this.get('streamStartDateFormatted');
    }
    set StreamStartDate(value) {
        if (value) {
            const date = new Date(value);
            void this.set({
                streamStartDate: date,
                streamStartDateFormatted: DateTimeUtils.formatDate(date, 'DD.MM.YYYY HH:mm')
            });
        }
    }
    get Localize() {
        return this.get('localizedLIVE');
    }
    set Localize(value) {
        void this.set('localizedLIVE', value);
    }
    get isShorts() {
        return this.get('isShorts');
    }
    set isShorts(value) {
        void this.set('isShorts', value);
    }
    constructor() {
        super();
        this.externalScreenInitWidth = 545;
        this.externalScreenInitHeight = 343;
        this.locKeyOfLIVELabel = 'panel.VideoWidget.TimeDateLabelTextForLIVE';
        this._extLinksObserver = new ExternalLinksObserver();
        this.onUpdateYtExternalLinkEvent = (link) => {
            if (link instanceof YoutubeExtLink && this.Link.id === link.id) {
                this.Link = link;
                this.updateLinkValues();
            }
        };
    }
    oncomplete() {
        super.oncomplete();
        void this.set('visible', true);
        this.Localize = Resources.getResource(this.locKeyOfLIVELabel);
        this.on('onCardClick', this.onCardClick);
        this.updateLinkValues();
        this._extLinksObserver.subscribeToUpdate(this.onUpdateYtExternalLinkEvent);
        this._extLinksObserver.subscribeToYtUpdate(this.onUpdateYtExternalLinkEvent);
    }
    dispose() {
        this._extLinksObserver.unsubscribeToUpdate(this.onUpdateYtExternalLinkEvent);
        this._extLinksObserver.unsubscribeToYtUpdate(this.onUpdateYtExternalLinkEvent);
    }
    updateLinkValues() {
        this.VideoPreviewURL = this.Link.config.videoImage;
        this.ChannelName = this.Link.config.channelTitle;
        this.ChannelPic = this.Link.config.channelImage;
        this.Title = this.Link.config.videoTitle;
        this.StreamHasBeenAlreadyEnded = this.Link.config.streamHasBeenAlreadyEnded;
        this.IsLIVE = this.Link.config.getStreamOnline();
        this.StreamStartDate = this.Link.config.getStreamStartDate();
        this.isShowData = ExtLinkUtils.showDateIfNeeded(this.Link);
        this.isShorts = this.Link.config.isShorts;
    }
    getType() {
        return ControlsTypes.VideoWidgetItemSideBar;
    }
    onCardClick() {
        if (this.Link.clientUseInternalBrowser) {
            const screenInitData = {
                ClientUseInternalBrowser: this.Link.clientUseInternalBrowser,
                Text: ExtLinkUtils.getEmbedYouTubeLinkByVideoID(this.Link.videoID),
                Tool: this.Link,
                ResizableScreen: true,
                ScreenWidth: this.externalScreenInitWidth,
                ScreenHeight: this.externalScreenInitHeight,
                ScreenName: this.Link.config.videoTitle
            };
            void externalScreenHandler.Show(screenInitData, true);
        }
        else {
            window.open(this.Link.urlStr);
        }
    }
}
ContainerControl.extendWith(VideoWidgetItemSideBar, {
    template: VideoWidgetItemSideBarTemplate,
    data: function () {
        return {
            visible: true,
            externalLink: null,
            videoPreviewURL: null,
            channelName: null,
            channelPic: null,
            title: null,
            streamHasBeenAlreadyEnded: null,
            isLIVE: null,
            streamStartDateFormatted: null,
            isShowData: null,
            isShorts: false
        };
    }
});
